import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageShell } from "../components/PageShell";
import { fetchCompanyIndex } from "../lib/api";

const MAIN = [
  { to: "/", label: "Home", desc: "Overview, leaderboards and search" },
  { to: "/screener", label: "Screener", desc: "Filter the S&P 500 by concentration dimension, threshold and sector" },
  { to: "/who-buys", label: "Customer Map", desc: "Reverse view — who depends on whom" },
  { to: "/contact", label: "Contact", desc: "Get in touch" },
  { to: "/privacy", label: "Privacy Policy", desc: "How we handle your data" },
  { to: "/terms", label: "Terms of Use", desc: "Rules of the road" },
];
const DIMS = [
  { to: "/screener?dimension=customer", label: "Customer concentration" },
  { to: "/screener?dimension=geographic", label: "Geographic concentration" },
  { to: "/screener?dimension=supplier", label: "Supplier concentration" },
  { to: "/screener?dimension=product", label: "Product concentration" },
  { to: "/screener?dimension=credit", label: "Credit concentration" },
];

export default function Sitemap() {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    fetchCompanyIndex().then(setCompanies).catch(() => {});
  }, []);

  return (
    <PageShell eyebrow="Index" title="Sitemap" wide>
      <div className="mt-10 grid gap-12 md:grid-cols-2">
        <section>
          <h2 className="font-heading text-lg font-semibold text-[#1a1a18]">Pages</h2>
          <ul className="mt-4 space-y-3">
            {MAIN.map((p) => (
              <li key={p.to}>
                <Link to={p.to} className="font-medium text-[#1a1a18] underline-offset-2 hover:underline">{p.label}</Link>
                <span className="ml-2 text-sm text-neutral-500">{p.desc}</span>
              </li>
            ))}
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-lg font-semibold text-[#1a1a18]">Screener views</h2>
          <ul className="mt-4 space-y-3">
            {DIMS.map((d) => (
              <li key={d.to}>
                <Link to={d.to} className="font-medium text-[#1a1a18] underline-offset-2 hover:underline">{d.label}</Link>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <section className="mt-14">
        <h2 className="font-heading text-lg font-semibold text-[#1a1a18]">
          Companies {companies.length > 0 && <span className="text-sm font-normal text-neutral-400">({companies.length})</span>}
        </h2>
        <div data-testid="sitemap-companies" className="mt-4 grid grid-cols-1 gap-x-8 gap-y-1.5 sm:grid-cols-2 lg:grid-cols-3">
          {companies.map((c) => (
            <Link key={c.ticker} to={`/company/${c.ticker}`}
              className="truncate text-sm text-neutral-600 underline-offset-2 hover:text-[#1a1a18] hover:underline">
              {c.name} <span className="font-mono text-xs text-neutral-400">({c.ticker})</span>
            </Link>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
